import React from "react";

import styles from "../../JobShiftPreStart/JobShiftPreStartView.module.css";

const renderItems = (items = []) => {
  if (!Array.isArray(items) || items.length === 0) {
    return <div className={styles.PreviewPadding}>No method items available</div>;
  }

  return (
    <ul className={styles.PreviewMethodItemTypeGrid}>
      {items.map((item, index) => (
        <li className={styles.PreviewMethodItemTypeGridItem} key={item.id || index}>
          <svg width="14" height="14" viewBox="0 0 16 16" className={styles.PreviewMethodItemCheckbox} aria-hidden="true">
            <rect x="0.75" y="0.75" width="14.5" height="14.5" rx="3" fill="#10B981" stroke="#10B981" />
            <path d="M4 8.3 L7 11 L12 4.8" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span>{item && item.method_item ? item.method_item : ""}</span>
        </li>
      ))}
    </ul>
  );
};

export default function EmergencyPlanRescueEquipmentSection({ section, sectionNumber = 3 }) {
  const data = section && section.data ? section.data : {};
  const groups = [
    ["Licences & Competencies", data.licences_competencies],
    ["Rescue PPE", data.rescue_ppe],
    ["Rescue Equipment", data.rescue_equipment]
  ];

  return (
    <div className={styles.PreviewSectionBlock}>
      <div className={styles.PreviewSectionHead}>
        <span className={`${styles.PreviewSectionNum} ${styles.PreviewSectionNumPreview}`} style={{ background: "#e9c84a", color: "#1f1031" }}>
          {sectionNumber}
        </span>
        Rescue Equipment &amp; Staging
      </div>
      <div className={styles.PreviewSectionBody}>
        {groups.map(([title, group]) => (
          <React.Fragment key={title}>
            <div className={`${styles.PreviewSectionSubHead} ${styles.EmergencyPlanEquipmentGroupHead}`}>{title}</div>
            {renderItems(group && group.method_items)}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
